import { useState } from "react"
import { VALORE_MIN } from "../api/tipi"
import type { ValueHalf } from "../api/tipi"
import "./pulsantiera.css"

interface Props {
  valore: ValueHalf | null
  nc: boolean
  disabilitato?: boolean
  onConferma: (valore: ValueHalf) => void
}

/** Il ripiego della corolla: dieci tasti più il mezzo punto.
 *
 *  Qui il tocco è immediato e irreversibile, quindi i 44px valgono in pieno
 *  e sono rispettati con margine (DESIGN.md §7).
 */
export function Pulsantiera({ valore, nc, disabilitato = false, onConferma }: Props) {
  const interoScelto = valore != null && !nc ? Math.floor(valore / 2) : null
  const [mezzo, setMezzo] = useState(valore != null ? valore % 2 === 1 : false)

  const scegli = (intero: number) => onConferma((intero * 2 + (mezzo ? 1 : 0)) as ValueHalf)

  return (
    <div className="pulsantiera">
      <div className="pulsantiera__griglia">
        {Array.from({ length: 10 }, (_, k) => {
          const intero = k + 1
          const acceso = !nc && intero === interoScelto
          return (
            <button
              key={intero}
              type="button"
              className="pulsantiera__tasto"
              aria-pressed={acceso}
              disabled={disabilitato}
              onClick={() => scegli(intero)}
            >
              {intero}
              {acceso && valore! % 2 === 1 && <span aria-hidden="true">½</span>}
            </button>
          )
        })}
      </div>
      <button
        type="button"
        className={`bottone pulsantiera__mezzo ${mezzo ? "acceso" : ""}`}
        aria-pressed={mezzo}
        disabled={disabilitato}
        onClick={() => {
          const prossimo = !mezzo
          setMezzo(prossimo)
          // Se un voto c'è già, il mezzo punto lo corregge subito invece di
          // restare in attesa del prossimo tocco.
          if (interoScelto != null) {
            onConferma((interoScelto * 2 + (prossimo ? 1 : 0)) as ValueHalf)
          }
        }}
      >
        ½ mezzo punto
      </button>
    </div>
  )
}

export { VALORE_MIN }
